import { render, staticRenderFns } from "./WhatsappContents.vue?vue&type=template&id=399c8c4a&"
import script from "./WhatsappContents.vue?vue&type=script&lang=js&"
export * from "./WhatsappContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports